<template>
  <div class="hello">
    <el-card shadow="never">
      <div slot="header" class="clearfix">
        <div>
          <!-- <span>{{hallInfo.hallName}}</span> -->
          <span>请选择您所需要预约的大厅</span>
          <span>{{ data.length === 0 ? '加载中' : active?data[active].deptName:hallInfo.hallName?hallInfo.hallName:'请选择大厅' }}</span>
        </div>
       <div class="input-left">
         <el-input
             v-model="keyword"
             @change="changes"
             placeholder="请输入大厅名称"
             clearable
         >
           <i slot="prefix" class="el-input__icon el-icon-search"></i>
         </el-input>
       </div>
      </div>
      <div class="box">
        <div v-for="(i,index) in data"
             class="items"
             :class="active==index?'activeClass':''"
             @click="itemsClick(index)">
          {{ i.hallName }}
        </div>
      </div>
    </el-card>
    <div class="pages">
      <el-pagination
          :current-page="page"
          :page-size="size"
          :total="total"
          :page-sizes="[20, 40]"
          background
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange">
      </el-pagination>
    </div>
    <el-dialog
  title="大厅信息"
  :visible.sync="dialogVisible"
  width="50%"
  >
    <el-descriptions title="" border :column="3">
    <el-descriptions-item label="大厅名称">{{hallInfo.hallName}}</el-descriptions-item>
    <el-descriptions-item label="联系电话">{{hallInfo.phone}}</el-descriptions-item>
    <el-descriptions-item label="投诉电话">{{hallInfo.complaintPhone}}</el-descriptions-item>
    <el-descriptions-item label="工作时间"><div >{{hallInfo.workTimeRange}}</div></el-descriptions-item>
    <el-descriptions-item label="地址">{{hallInfo.address}}</el-descriptions-item>
    <el-descriptions-item label="交通指引">{{hallInfo.busRoute}}</el-descriptions-item>
    <el-descriptions-item label="大厅简介">{{hallInfo.introduction}}</el-descriptions-item>
</el-descriptions>
  <span slot="footer" class="dialog-footer">
    <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
  </span>
</el-dialog>
  </div>
</template>

<script>
import wasm from "@/mixins/wasm"
import {getDeptList} from "@/api/dept"
import {getHallInfo} from "@/api/hall";
export default {
  name: 'fiveStep',
  mixins: [wasm],
  async mounted() {
    await this.initwasm().then(() => {
      this.getHallInfo()
    })
  },
  data() {
    return {
      keyword: '',
      active: null,
      page: 1,
      dialogVisible:false,//大厅详情弹窗
      size: 20,
      total: 1,
      oldListist:[],
      data: [],
      hallInfo: {}
    }
  },
  methods: {
    getHallInfos(){
      var data={
        hallId: this.data[0].hallId
      }
      getHallInfo(data).then(res => {
        console.log(res.data.info)
        this.hallInfo = res.data.info
        this.dialogVisible=true
      })
    },
    changes(){
      this.page=1
      this.data=[]
      if(this.keyword==''){
        this.data=this.oldList
      }else{
        for(let i=0;i<this.oldList.length;i++){
          if(this.oldList[i].hallName.indexOf(this.keyword)>-1){
            this.data.push(this.oldList[i])
          }
        }
      }
    },
    getHallInfo() {
      let data = {
        // deptId: this.$store.state.dept.deptId
        deptName: this.$store.state.dept.deptName,
      }
      getDeptList(this.page, this.size, data).then(res => {
          this.data = res.data.rows
          this.oldList= res.data.rows
          this.total = res.data.records
      })
    },

    handleSizeChange(val) {
      this.size = val
      this.getHallInfo()
    },
    handleCurrentChange(val) {
      this.page = val
      this.getHallInfo()
    },
    itemsClick(index) {
      this.active = index
      this.$store.commit('setDept', this.data[index])
      this.getHallInfos()
    }
  }
}
</script>

<style lang="less" scoped>
.clearfix {
  display: flex;
  justify-content: space-between;
  align-items: center;

  .input-left {
    width: 20%;
  }

  span {
    margin: 0 10px;
  }

  span:nth-child(1) {
    font-weight: 500;
  }

  span:nth-child(3) {
    color: #427AF4;
  }
}

.box {
  display: grid;
  padding: 10px;
  justify-content: space-between;
  grid-template-columns: repeat(4, 264px); /* 横向平均分为4列 */
  grid-template-rows: repeat(7, 70px); /* 纵向最大为7行，根据内容自动调整 */
  gap: 20px; /* 设置行和列之间的间隙 */
  height: 300px;
  overflow: auto;

  .items {
    box-shadow: 0px 4px 5.8px 0px #C0CBD769;
    padding: 20px;
    display: flex;
    align-items: center;
    cursor: pointer;
    border: 2px solid #fff;
  }

  .activeClass {
    background: #427AF4;
    color: #fff;
  }
}

::v-deep .pages {
  margin: 20px 0;

  .el-pagination {
    display: flex;
  }

  .el-pagination__sizes {
    margin-left: auto;
  }
}
</style>
